export type GitProviderKind = 'github' | 'bitbucket_cloud' | 'bitbucket_server' | 'gitlab' | 'unknown';

export interface GitProviderInfo {
  kind: GitProviderKind;
  label: string;
  project_key?: string;
  slug?: string;
}

function stripUserinfo(url: string): string {
  return url.replace(/^([a-z][a-z0-9+.-]*:\/\/)[^@/]*@/i, '$1');
}

export function detectGitProvider(rawUrl: string): GitProviderInfo {
  const trimmed = rawUrl.trim();
  if (trimmed === '') return { kind: 'unknown', label: '' };
  let parsed: URL;
  try {
    parsed = new URL(stripUserinfo(trimmed));
  } catch {
    return { kind: 'unknown', label: '' };
  }
  const host = parsed.hostname.toLowerCase();
  if (/(^|\.)github\.com$/.test(host)) return { kind: 'github', label: 'GitHub' };
  if (/(^|\.)bitbucket\.org$/.test(host)) return { kind: 'bitbucket_cloud', label: 'Bitbucket Cloud' };
  if (/(^|\.)gitlab\.com$/.test(host)) return { kind: 'gitlab', label: 'GitLab' };
  const m = /^(?:.*?)\/scm\/([^/]+)\/([^/]+?)(?:\.git)?\/?$/.exec(parsed.pathname);
  if (m) {
    return {
      kind: 'bitbucket_server',
      label: 'Bitbucket Data Center',
      project_key: m[1] ?? '',
      slug: m[2] ?? ''
    };
  }
  if (!/\/[^/]+\/[^/]+/.test(parsed.pathname)) return { kind: 'unknown', label: '' };
  return { kind: 'unknown', label: 'Other / self-hosted' };
}

export function browseUrlToCloneUrl(rawUrl: string): string | null {
  let parsed: URL;
  try {
    parsed = new URL(stripUserinfo(rawUrl.trim()));
  } catch {
    return null;
  }
  const m = /^(.*?)\/projects\/([^/]+)\/repos\/([^/]+)(?:\/.*)?$/.exec(parsed.pathname);
  if (!m) return null;
  const [, context = '', project_key = '', slug = ''] = m;
  if (project_key === '' || slug === '') return null;
  return `${parsed.protocol}//${parsed.host}${context}/scm/${project_key}/${slug}.git`;
}

export function credentialPlaceholder(kind: GitProviderKind): string {
  switch (kind) {
    case 'github':
      return 'github_pat_… or ghp_…';
    case 'bitbucket_cloud':
    case 'bitbucket_server':
      return 'Bitbucket HTTP access token';
    default:
      return 'HTTPS access token';
  }
}
